import React from "react";

export default function About() {
  return (
    <div className="container">
      <h2 id="about" className="text-center">About</h2>
      <div className="container text-center my-5">
        <h3 className="text-center mt-5">Skill Summary 🚀</h3>
        <hr className="w-25 mx-auto mb-5" />
        <div className="row row-cols-4">
          <div className="col">
            <img className="mx-auto shadow-lg p-3 mb-5 bg-body-tertiary rounded" src="./assets/html.png" height="100px" alt="" />
          </div>
          <div className="col">
            <img className="mx-auto shadow-lg p-3 mb-5 bg-body-tertiary rounded" src="./assets/css.png" height="100px" alt="" />
          </div>
          <div className="col">
            <img className="mx-auto shadow-lg p-3 mb-5 bg-body-tertiary rounded" src="./assets/bootstrappng.png" height="100px" alt="" />
          </div>
          <div className="col">
            <img className="mx-auto shadow-lg p-3 mb-5 bg-body-tertiary rounded" src="./assets/javascript.png" height="100px" alt="" />
          </div>
        </div>
      </div>

      <div className="container text-center my-5">
        <div className="row row-cols-4">
          <div className="col">
            <img className="mx-auto shadow-lg p-3 mb-5 bg-body-tertiary rounded" src="./assets/java.png" height="100px" alt="" />
          </div>
          <div className="col">
            <img className="mx-auto shadow-lg p-3 mb-5 bg-body-tertiary rounded" src="./assets/android.png" height="100px" alt="" />
          </div>
          <div className="col">
            <img className="mx-auto shadow-lg p-3 mb-5 bg-body-tertiary rounded" src="./assets/node.png" height="100px" alt="" />
          </div>
          <div className="col">
            <img className="mx-auto shadow-lg p-3 mb-5 bg-body-tertiary rounded" src="./assets/logo-react.png" height="100px" alt="" />
          </div>
        </div>
      </div>

      <div className="container text-center">
        <div className="row">
          <div className="col">
            <img className="ms-5 shadow-lg p-3 mb-5 bg-body-tertiary rounded" src="./assets/github.png" height="100px" alt="" />
          </div>
          <div className="col">
            <img className="ms-5 shadow-lg p-3 mb-5 bg-body-tertiary rounded" src="./assets/git.png" height="100px" alt="" />
          </div>
          <div className="col">
            <img className="me-5 shadow-lg p-3 mb-5 bg-body-tertiary rounded" src="./assets/ms.png" height="100px" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}
